
<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <div class="row">
            <div class="col-lg-12">
                <h3>Step 1: Upload Documents</h3>
            </div>
            <div class="col-lg-8">
                <document-upload-guide-popup>
                </document-upload-guide-popup>
                <div class="row form-options">
                    <!--<div v-if="instance != 'United Arab Emirates'" class="col-lg-6">-->
                        <!--<identity-type :data-segment-id="dataSegmentId" :disabled="false"></identity-type>-->
                    <!--</div>-->
                    <template v-if="tempCountry=='UK'  && getField('type') != 'company'">
                        <div class="col-lg-6">
                            <generic-drop-down :data-segment-id="dataSegmentId" 
                                :field="{
                                    isRequired: true,
                                    isLocked: true,
                                    title: 'Select ID Document Type',
                                    label: 'ID Document Type',
                                    placeholder: this.isCardType ? photoIdCardTypes.find((element) => element.value == this.isCardType).text : 'Select ID Document Type',
                                    options: photoIdCardTypes,
                                    key: 'identityInfo.cardType',
                                    isDocType: this.isCardType
                                }"      
                                :disabled="false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6">
                            <cropper ref="cropper" 
                                v-if="showPhotoIdFrontDocumentUK"
                                :formData="formData2"
                                :isOcrField = "true"
                                :field="{
                                        isRequired: true,
                                        isLocked: true,
                                        key: 'documentInfo.identity.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identity.originalFileName',
                                        label: 'ID Front Scan Copy',
                                         placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-6" v-if="showPhotoIdBackDocumentUK">
                            <id-back-cropper ref="cropper" 
                            :disabled="!allowPhotoIdBackDocumentUK"
                            :isOcrField = "true"
                            :field="{
                                isRequired: true,
                                isLocked: true,
                                key: 'documentInfo.identityBack.fileName',
                                originalFileNameKey:
                                    'documentInfo.identityBack.originalFileName',
                                label: 'ID Back Scan Copy',
                                 placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                            }"  
                            :formData="formData2"></id-back-cropper>
                        </div>
                        

                        <div class="col-12">
                            <hr/>
                        </div>
                        <div class="col-lg-6">
                            <generic-drop-down :data-segment-id="dataSegmentId" 
                                :field="{
                                        isRequired: this.addressProofReq,
                                        isLocked: true,
                                        title: 'Select Proof of Address Document Type',
                                        label: 'Proof of Address Document Type',
                                        placeholder: this.isAddrProf ? proofOfAddressCardTypesUK.find((element) => element.value == this.isAddrProf).text : 'Select Proof of Address Document Type',
                                        options: proofOfAddressCardTypesUK,
                                        key: 'addressProofDocumentType',
                                        isDocType: this.isAddrProf
                                    }"
                            :disabled="false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6" v-if="showAddressDoc">
                            <cropper ref="cropper" 
                                :formData="formData2"
                                :verification="true"
                                :isOcrField = "false"
                                :field="{
                                        isRequired: this.addressProofReq,
                                        isLocked: true,
                                        key: 'documentInfo.fieldAddressProof.fileName',
                                        originalFileNameKey:
                                            'documentInfo.fieldAddressProof.originalFileName',
                                        label: 'Proof of Address Document Scan Copy',
                                        placeholder : placeHolderFieldWithPDF,
                                        fileTypes : fileTypesForPDF,
                                        disAllowPDF : false
                                    }"
                            ></cropper>
                        </div>
                        <div v-if="$store.state.registration.form.identityInfo.type && this.$route.path.includes('deep')" class="col-lg-12">
                            <b-form-group
                                    :label=dropzoneLabel
                                    label-for="contact-email-input"
                            >
                                <div>
                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-removed-file="onFileRemove"
                                                @vdropzone-error="onError"
                                                @vdropzone-mounted="prePopulate">
                                    </vue-dropzone>
                                </div>
                                <small class="mt-2"><em class="dropzoneText">Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                    MAX)</em></small>
                            </b-form-group>
                        </div>
                    </template>
                    <template v-else-if="(tempCountry=='Qatar' || tempCountry=='UAE') && getField('type') != 'company'">
                        <div class="col-lg-6">
                            <cropper ref="cropper"
                                     :formData="formData2"
                                     :isOcrField = "true"
                                     :field="{
                                        isRequired: true,
                                        isLocked: true,
                                        key: 'documentInfo.identity.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identity.originalFileName',
                                        label: 'Passport photo page scan copy',
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-12">
                            <hr/>
                        </div>
                        <div class="col-lg-6">
                            <generic-drop-down :data-segment-id="dataSegmentId"
                                               :field="{
                                    isRequired: false,
                                    isLocked: true,
                                    title: 'Select ID Document Type',
                                    label: 'ID Document Type',
                                    placeholder: this.isCardType ? photoIdCardTypes.find((element) => element.value == this.isCardType).text :'Select ID Document Type',
                                    options: photoIdCardTypes,
                                    key: 'identityInfo.cardType',
                                    isDocType: this.isCardType
                                }"
                                               :disabled="false"></generic-drop-down>
                        </div>
                        <div class="col-lg-6">
                            <cropper ref="cropper"
                                     v-if="showPhotoIdFrontDocumentUK"
                                     :formData="formData2"
                                     :isOcrField = "true"
                                     :field="{
                                        isRequired: true,
                                        isLocked: true,
                                        key: 'documentInfo.fieldEmiratesID.fileName',
                                        originalFileNameKey:
                                            'documentInfo.fieldEmiratesID.originalFileName',
                                        label: 'ID Front Scan Copy',
                                        placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                                    }"
                            ></cropper>
                        </div>
                        <div class="col-lg-6" v-if="showPhotoIdBackDocumentUK">
                            <id-back-cropper ref="cropper"
                                             :isOcrField = "true"
                                             :field="{
                                isRequired: true,
                                isLocked: true,
                                key: 'documentInfo.fieldEmiratesIDBack.fileName',
                                originalFileNameKey:
                                    'documentInfo.fieldEmiratesIDBack.originalFileName',
                                label: 'ID Back Scan Copy',
                                placeholder : placeHolderField,
                                fileTypes : fileTypes,
                                disAllowPDF : disAllowPDF
                            }"
                                             :formData="formData2"></id-back-cropper>
                        </div>
                        <div class="col-12">
                            <hr/>
                        </div>
                        <div :class="fieldVisaPage.show ? 'col-lg-6' : ''">
                            <div v-if="fieldVisaPage.show">
                                <visa-page
                                        :profile-type="profileType"
                                ></visa-page>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div>
                                <address-proof></address-proof>
                            </div>
                        </div>
                        <div
                                v-if="
                                $store.state.registration.form.identityInfo.type
                            "
                                class="col-lg-12"
                        >
                            <b-form-group
                                    label="Please upload all relevant documents"
                                    label-for="contact-email-input"
                            >
                                <div>
                                    <vue-dropzone
                                            id="dropzone"
                                            ref="myVueDropzone"
                                            :options="dropzoneOptions"
                                            @vdropzone-complete="afterComplete"
                                            @vdropzone-removed-file="onFileRemove"
                                            @vdropzone-error="onError"
                                            @vdropzone-mounted="prePopulate"
                                    ></vue-dropzone>
                                </div>
                                <small class="mt-2"
                                ><em class="dropzoneText"
                                >Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                    MAX)</em
                                ></small
                                >
                            </b-form-group>
                        </div>
                    </template>
                    <template v-else>
                        <div v-if="instance == 'Pakistan' && this.$store.getters.form.type!='company'" class="col-lg-6">
                            <card-type :data-segment-id="dataSegmentId" :disabled="false"></card-type>
                        </div>
                        <div class="col-lg-6">
                            <cropper 
                                  ref="cropper" 
                                 :formData="formData2" 
                                 :isOcrField ="true" 
                                 :field="{
                                        isRequired: true,
                                        isLocked: true,
                                        key: 'documentInfo.identity.fileName',
                                        originalFileNameKey:
                                            'documentInfo.identity.originalFileName',
                                        label: getField('type') != 'company' ? 'ID Front Scan Copy': labelForCompanyId(),
                                         placeholder : placeHolderField,
                                        fileTypes : fileTypes,
                                        disAllowPDF : disAllowPDF
                                    }">
                             </cropper>
                        </div>

                        <div v-if="!backScanCopyHidden  && getField('type') != 'company'" class="col-lg-6" >
                            <id-back-cropper 
                                ref="cropper" 
                                :formData="formData2" 
                                :isOcrField = true
                                :field="{
                                    isRequired: true,
                                    isLocked: true,
                                    key: 'documentInfo.identityBack.fileName',
                                    originalFileNameKey:
                                        'documentInfo.identityBack.originalFileName',
                                    label: 'ID Back Scan Copy',
                                    placeholder : placeHolderField,
                                    fileTypes : fileTypes,
                                    disAllowPDF : disAllowPDF
                                    }">
                            </id-back-cropper>
                        </div>
                        
                        <!--<div -->
                        <!--v-if="instance == 'Pakistan' && this.$store.getters.form.type!='company'"-->
                        <!--class="col-lg-6">-->
                            <!--<LicenseFrontCropper ref="cropper"></LicenseFrontCropper>-->
                        <!--</div>-->

                        <!--<div -->
                        <!--v-if="instance == 'Pakistan' && this.$store.getters.form.type!='company'"-->
                        <!--class="col-lg-6">-->
                            <!--<LicenseBackCropper ref="cropper"></LicenseBackCropper>-->
                        <!--</div>-->

                        <div
                        v-if="country == 'Pakistan' && this.$store.getters.form.type!='company' && ( degreeCheck || employmentCheck) && $route.path.includes('deep')"
                        class="col-lg-6">
                            <ConsentForm
                            ></ConsentForm>
                            <small class="mt-2"><em class="dropzoneText">Please download the attached form by 
                            <a href='#' @click= 'consentFormDownload'>clicking here</a>, and upload the signed form</em>
                            </small>
                        </div>
                        
                        <!--if country is UAE-->
                        <div
                            v-if="instance != 'Pakistan' || this.$store.getters.form.type=='company'"
                            class="col-lg-12 row"
                        >
                            <div :class="fieldEmiratesID.show ? 'col-lg-6' : ''">
                                <div v-if="fieldEmiratesID.show">
                                    <emirates-id
                                        :profile-type="profileType"
                                    ></emirates-id>
                                </div>
                            </div>
                            <div
                                :class="fieldEmiratesIDBack.show ? 'col-lg-6' : ''"
                            >
                                <div v-if="fieldEmiratesIDBack.show">
                                    <emirates-id-back
                                        v-validate="{
                                            required: false,
                                        }"
                                        :profile-type="profileType"
                                    ></emirates-id-back>
                                </div>
                            </div>
                            <div class='col-lg-6'>
                                <div >
                                    <visa-page
                                        :profile-type="profileType"
                                    ></visa-page>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div>
                                    <address-proof></address-proof>
                                </div>
                            </div>
                        </div>
                        <div v-if="$store.state.registration.form.identityInfo.type && this.$route.path.includes('deep')" class="col-lg-12">
                            <b-form-group
                                    :label=dropzoneLabel
                                    label-for="contact-email-input"
                            >
                                <div>
                                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-removed-file="onFileRemove" 
                                                @vdropzone-error="onError"
                                                @vdropzone-mounted="prePopulate"
                                                >
                                    </vue-dropzone>
                                </div>
                                <small class="mt-2"><em class="dropzoneText">Upload either DOC, DOCX, PDF, PNG, JPG (5MB
                                    MAX)</em></small>
                            </b-form-group>
                        </div>
                    </template>


                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <base-button btn-type="submit" btn-variant="primary" btn-label="CONTINUE"
                            :class="loading ? 'disabled' : ''" :disabled="loading"></base-button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mb-4 mb-md-0 form-options">
                <b-form-group label="SAMPLE DOCUMENT" label-for="sampleId">
                         
				<img 
                :style="{'display': this.customerType!='company' && this.formData2.documentValidation  ?'inline-block' : 'none' }"
                style="height: 30px !important;
                    position: absolute;
                    top: -47px;
                    left: 337px;"
                    @click="openGuideAfterFail"                  
                    :src="`${this.filesUrl}logo/circle-info.png`"  
                 >
                    <img
                            style="max-width: 270px"
                            v-authenticated-image="cardImageUrl"
                    />
                </b-form-group>
            </div>
        </div>
    </b-form>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'
import axios from 'axios'

import IdentityType from '@/components/registration/IdentityType.vue'
import CardType from '@/components/registration/CardType.vue'
import GenericDropDown from '@/components/registration/GenericDropDown.vue'

//import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'
import VisaPage from '@/components/registration/VisaPage.vue'
import EmiratesId from '@/components/registration/EmiratesId.vue'
import EmiratesIdBack from '@/components/registration/EmiratesIdBack.vue'
import AddressProof from '@/components/registration/AddressProof.vue'
import Cropper from '@/components/registration/Cropper.vue'
import IdBackCropper from '@/components/registration/IdBackCropper.vue'
import AdditionalDocument from '@/components/registration/AdditionalDocument.vue'
import proofOfEmployment from '@/components/registration/ProofOfEmployment.vue'
import EducationalDocument from '@/components/registration/EducationalDocument.vue'
import vue2Dropzone from 'vue2-dropzone'
import ConsentForm from '@/components/registration/ConsentForm.vue'
import LicenseFrontCropper from '@/components/registration/LicenseFrontCropper.vue'
import LicenseBackCropper from '@/components/registration/LicenseBackCropper.vue'
import DocumentUploadGuidePopup from '../../components/popups/DocumentUploadGuidePopup.vue'


import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import resource from '@/api/resource'
import { ocr,setDocumetSummary } from '../../utils/functions';

const viewBrandingApi = new resource('configurations/branding')
const modulesApi = new resource('configurations/modules')

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        DocumentUploadGuidePopup,
        IdentityType,
        CardType,
        GenericDropDown,
        Cropper,
        ConsentForm,
        //IdentityDocument,
        UtilityBill,
        VisaPage,
        EmiratesId,
        AddressProof,
        EmiratesIdBack,
        IdBackCropper,
        LicenseFrontCropper,
        LicenseBackCropper,
        AdditionalDocument,
        proofOfEmployment,
        EducationalDocument,
        vueDropzone: vue2Dropzone
    }, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            formData2:{
                documentValidation: null,
            },
            dataFetch: false,
            // soundeffect: new Audio(),
            country: process.env.VUE_APP_COUNTRY,
            tempCountry: process.env.VUE_APP_COUNTRY_TEMP,
            filesUrl:process.env.VUE_APP_FILE_SERVICE_URL,
            liveness: null,
            nameScreening: null,
            riskFactor: null,
            documentUpload: null,
            documentValidation: null,
            degreeCheck:null,
            employmentCheck:null,
            redirection: true,
            validateFront : true,
            validateBack: true,
            associateData: [],
            fieldVisaPage: {
                show: true,
            },
            fieldEmiratesID: {
                show: true,
            },
            fieldAddressProof: {
                show: true,
            },
            fieldEmiratesIDBack: {
                show: true,
            },
            profileType: '',
            cardImageUrl : '',
            backScanCopyHidden: false,
            dropzoneLabel : "Please upload all relevant documents.",
            // dropzoneLabel : "Please upload all relevant documents (last degree/transcript, last employment certificate, etc)(last degree/transcript, last employment certificate, etc)",
            dropzoneOptions: {
                url: process.env.VUE_APP_FILE_SERVICE_URL,
                autoProcessQueue: true,
                // acceptedFiles: "image/jpeg,image/png,image/gif",
                acceptedFiles: "application/pdf,.doc,.docx , image/png, .jpg,.jpeg",
                uploadMultiple: false,
                maxFiles: 10,
                maxFilesize: 5,
                addRemoveLinks: true,
                dictDefaultMessage:
                    "Drop file here or Select file",
                init: function () {
                    this.on(
                        "sending", function (file, xhr, formData) {
                            formData.append('type', 'otherDocuments');
                        })
                }
            },
            photoIdCardTypeLists: [
                {
                        text: 'No Document Type Selected',
                        value: '',
                },
                {
                    text: 'Passport',
                    value: 'passport',
                },
                {
                    text: 'Passport MRZ',
                    value: 'passportMRZ',
                },
                            {
                                text: 'Driving Licence',
                                value: 'license',
                            },
                            {
                                text: 'Biometric Residence Permit',
                                value: 'brp',
                            },
                            {
                                text: 'Qatar Residence Permit',
                                value: 'qrp',
                            },
                            {
                                text: 'UAE Old Resident Card',
                                value: 'uaeOldResidentCard',
                            },
                            {
                                text: 'UAE Smart Resident Card',
                                value: 'uaeSmartResidentCard',
                            },
                        ],
                proofOfAddressCardTypesUK: [
                            {
                                text: 'Driving Licence',
                                value:'Driving Licence',
                            },
                            {
                                text: 'Credit Card statement',
                                value:'Credit Card statement',
                            },
                            {
                                text: 'Bank statement',
                                value:'Bank statement',
                            },
                            {
                                text: 'Tax Bill',
                                value:'Tax Bill',
                            },
                            {
                                text: 'Utility Bill',
                                value:'Utility Bill',
                            },
                            {
                                text: 'Mortgage Statement',
                                value:'Mortgage Statement',
                            },
                            {
                                text: 'Rental Agreement',
                                value:'Rental Agreement',
                            },
                        ],
            placeHolderField :'Select scan copy (JPG, PNG, PDF or JPEG file)',
            placeHolderFieldWithPDF :'Select scan copy (JPG, PNG, PDF or JPEG file)',
            fileTypes:"image/*,application/pdf",
            fileTypesForPDF:"image/*,application/pdf",
            disAllowPDF : false
        }
    }, // End of Component > data

    created() {
        // if (this.field.key == 'pepDeclaration.other') {
        if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.identityInfo.type
                },
                (newValue, oldValue) => {
                    if (newValue == 'passport' || newValue == 'passportMRZ') {
                        this.backScanCopyHidden = true
                    } else {
                        this.backScanCopyHidden = false
                    }
                }
            )
        }
        else
        {
            // this.dropzoneLabel ="Please upload all relevant documents (trade license, other documents, etc)"
        }
        // }
    },

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form', 'cardTypeOverride','getRegState','getField']),
        addressProofReq() {
            if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                return true
            }
            return false
        },
        isCardType(){
               return this.$store.getters.getField("identityInfo.cardType")
            },

        isAddrProf(){
              return this.getRegState('addressProofDocumentType')
            },

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        instance() {
            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'id',
                })
                return 'Pakistan'
            }  else {
                this.$store.commit('updateField', {
                    key: 'identityInfo.type',
                    value: 'passport',
                })
                return process.env.VUE_APP_COUNTRY
            }
        },
        showPhotoIdFrontDocumentUK() {
            let cardType = this.$store.getters.getField("identityInfo.cardType");
            return !!cardType;
        },
        showPhotoIdBackDocumentUK() {
            let passportTypes = ['passport', 'passportMRZ'] 
            let cardType = this.$store.getters.getField("identityInfo.cardType");
            return !!cardType && !passportTypes.includes(cardType);
        },
        showAddressDoc()
        {
            let cardType = this.$store.getters.getField("documentInfo.fieldAddressProof.addressProofDocumentType");
            return !!cardType;
        },
        allowPhotoIdBackDocumentUK() {
            let cardType = this.$store.getters.getField("identityInfo.cardType");
            return !!cardType && cardType != 'passport' && !!this.$store.getters.getField("documentInfo.identity.fileName");
        },
        photoIdCardTypes(){
                let UKLists =['passport','license','brp']
                // let UAELists = ['passportMRZ','uaeOldResidentCard','uaeSmartResidentCard']
                // let QatarLists = ['passportMRZ','qrp']

                let UAELists = ['','uaeOldResidentCard','uaeSmartResidentCard']
                let QatarLists = ['','qrp']
                
                if( this.tempCountry =='UK'){
                    let array = this.photoIdCardTypeLists.filter((el)=> UKLists.includes(el.value)==true)
                    return array
                    // array.map(item => {
                    //     if (item.value.toLowerCase() === 'passportmrz') {
                    //         return { ...item, text: 'Overseas Passport' };
                    //     }
                    //     return item;
                    // });
                }
                else if(this.tempCountry == 'Qatar'){
                    return  this.photoIdCardTypeLists.filter((el)=> QatarLists.includes(el.value)==true)
                }
                else{
                    return  this.photoIdCardTypeLists.filter((el)=> UAELists.includes(el.value)==true)
                }
            },
            customerType(){
                return this.form.type
            }
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > watch
  |--------------------------------------------------------------------------
  */

    watch: {

        'form.identityInfo.cardType'(value, oldValue){
                if( oldValue && this.isOcrCountry() ){
                     this.ocrFieldReset(oldValue)
                }
                if(this.tempCountry == 'UK' && value) {
                    if(value == 'license') {
                        this.proofOfAddressCardTypesUK = this.proofOfAddressCardTypesUK.filter(el => el.text != 'Driving Licence');
                         if( this.getRegState('addressProofDocumentType') == 'Driving Licence'){
                        this.$store.commit('setValue', {
                            key: 'addressProofDocumentType',
                            value: null,
                        })
                        }
                    }
                    else if(!this.proofOfAddressCardTypesUK.find(el=>el.text =='Driving Licence')){
                        this.proofOfAddressCardTypesUK = [ {
                                text: 'Driving Licence',
                                value:'Driving Licence',
                            }, ...this.proofOfAddressCardTypesUK]
                        }
               }
            },
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        async 'form.documentInfo.identity.fileName'(value,oldValue) {
            try {
                // check if the value is not empty
                if(value!=null &&  typeof(value)=='string')
                {
                    // let ocrResponse = await this.ocrValidation(value,'FRONT')
                    if (   !value.split(".").includes("pdf") && this.isOcrCountry() 
                        && this.formData2.documentValidation ) {
                        this.$store.commit('setValue', {
                                            key:'cardTypeOverride',
                                            value: null
                                        });
                        await ocr(value, 'FRONT', null,true,this.twoIdentityDocs())
                        .then((result)=>{
                            if(result && result.result && result.card_type){
                                    this.$store.commit('setValue', {
                                        key:'cardTypeOverride',
                                        value: result.card_type
                                    });
                                }
                            result.fieldKey = 'documentInfo.identity.fileName'
                            this.$store.commit('setValue', {
                                                key: 'ocrStatusFront',
                                                value: result,
                                            })
                            setDocumetSummary(result,'identity')
                        })
                    }
                }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                     setDocumetSummary(false,'identity',true)
                                    }

            } catch (error) {
                console.log('OCR error 2',error)
            }
            this.$store.commit('setLoading', false)
        }, // End of user() method
        async 'form.documentInfo.identityBack.fileName'(value,oldValue) {
            try {
                // check if the value is not empty
                if(value!=null &&  typeof(value)=='string')
                {
                    // let ocrResponse = await this.ocrValidation(value,'BACK')
                    if (   !value.split(".").includes("pdf") && this.isOcrCountry() 
                        && this.formData2.documentValidation && this.$store.getters.form.type!='company') {
                        await ocr(value, 'BACK', this.cardTypeOverride ? this.cardTypeOverride.replace('FRONT', 'BACK') : null,true)
                        .then((result)=>{
                                        result.fieldKey = 'documentInfo.identityBack.fileName'
                                        this.$store.commit('setValue', {
                                                key: 'ocrStatusBack',
                                                value: result,
                                            })
                                        setDocumetSummary(result,'identityBack')
                                        }
                                        
                            )
                    }
                }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                       setDocumetSummary(false,'identityBack',true)
                                    }

            } catch (error) {
                console.log('OCR error 3',error)
            }
            this.$store.commit('setLoading', false)
        },
        async 'form.documentInfo.fieldEmiratesID.fileName'(value,oldValue) {
                try {
                    // check if the value is not empty
                    if(value!=null &&  typeof(value)=='string')
                    {
                        // let ocrResponse = await this.ocrValidation(value,'FRONT')
                        if (   this.isOcrCountry() && this.formData2.documentValidation && !value.split(".").includes("pdf")) 
                          {
                            this.$store.commit('setValue', {
                                key:'cardTypeOverride',
                                value: null
                            });
                            await ocr(value, 'FRONT',null,true)
                                .then((result)=>{
                                    if(result && result.result && result.card_type){
                                        this.$store.commit('setValue', {
                                            key:'cardTypeOverride',
                                            value: result.card_type
                                        });
                                    }

                                    result.fieldKey = 'documentInfo.fieldEmiratesID.fileName'
                                    this.$store.commit('setValue', {
                                        key: 'ocrStatusFront',
                                        value: result,
                                    })
                                    setDocumetSummary(result,'fieldEmiratesID')
                                })
                        }
                    }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                       setDocumetSummary(false,'fieldEmiratesID',true)
                    }

                } catch (error) {
                    console.log('OCR error 2',error)
                }
                this.$store.commit('setLoading', false)
            }, // End of user() method
            async 'form.documentInfo.fieldEmiratesIDBack.fileName'(value,oldValue) {
                try {
                    // check if the value is not empty
                    if(value!=null &&  typeof(value)=='string') {
                        // let ocrResponse = await this.ocrValidation(value,'BACK')
                        if (    this.$store.getters.form.type!='company' && this.isOcrCountry()
                            && this.formData2.documentValidation && !value.split(".").includes("pdf")
                        ) {
                            await ocr(value, 'BACK', this.cardTypeOverride ? this.cardTypeOverride.replace('FRONT', 'BACK') : null,true)
                                .then((result)=>{
                                    this.$store.commit('setValue', {
                                        key: 'ocrStatusBack',
                                        value: result,
                                    })
                                    setDocumetSummary(result,'fieldEmiratesIDBack')
                                })
                        }
                    }else if(oldValue!=null &&  typeof(oldValue)=='string' && this.$store.getters.form.type!='company'&& this.isOcrCountry() &&
                            this.formData2.documentValidation && !oldValue.split(".").includes("pdf")){
                                       setDocumetSummary(false,'fieldEmiratesIDBack',true)
                    }

                } catch (error) {
                    console.log('OCR error 3',error)
                }
                this.$store.commit('setLoading', false)
            },
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    async mounted() {
        if(this.tempCountry == 'UK' && this.isCardType) {
                    if(this.isCardType == 'license') {
                        this.proofOfAddressCardTypesUK = this.proofOfAddressCardTypesUK.filter(el => el.text != 'Driving Licence');
                    }
                }
        await this.getModuleData()
        if(this.liveness)
        {
            this.placeHolderField = 'Select scan copy (JPG, PNG or JPEG file)'
            this.fileTypes = "image/*"
            this.disAllowPDF = true
        }
        if(this.$route.path.includes('deep') && !this.getField('basicInfo.firstName') )
        {
            await this.getFormData()
        }
        this.getBrandingData()

        //save token in the state

        // this.country == process.env.VU
    }, // End of Component > watch

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
         ...mapMutations(['setValue']), 
                openGuideAfterFail(){
                       this.setValue({
                                key: 'isShowGuide',
                                value: true,
                            })
             },
         labelForCompanyId(){
               if(['UK'].includes(this.tempCountry)){
                 return "Certificate of incorporation"
               }
               else{
                 return "Trade License / Registration Certificate"
               }
            },
         twoIdentityDocs(){
                let countries = ['UAE','Qatar']
                if(countries.includes(this.tempCountry)){
                  return 'passportMRZ'
                }
                return false
             },
         isGenericDropdownCountry() {
            if (
                (this.country == 'United Arab Emirates' ||
                this.tempCountry == 'UK' ||
                this.tempCountry == 'Qatar') && this.customerType != 'company'
            ) {
                return true
            }
            return false
        },
         isOcrCountry(){
                if( this.country == 'United Arab Emirates' || this.country == 'Pakistan' ||  (this.tempCountry == 'UK' || this.tempCountry == 'Qatar')){
                    return true
                }
                return false
          },
         async ocrFieldReset(oldCardType) {
                let TypesForIdentityInfo = ['license','brp','URDU','SMART','nicopNew','nicopOld','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
                let TypesForPassport = ['passport','passportMRZ']
                let TypesForNationality = ['SMART','nicopNew','nicopOld','passport','passportMRZ', 'brp','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
                let TypesForGender = ['SMART','nicopNew','nicopOld','passport','passportMRZ', 'brp']
                let TypesForGeneric = ['license','SMART','URDU','nicopNew','nicopOld','passport','passportMRZ']
                let TypeForFatherName = ['SMART','nicopNew','nicopOld']
                let cardType = oldCardType

                if(TypesForGeneric.includes(cardType)){
                        this.$store.commit('updateField', {
                            key: 'basicInfo.firstName',
                            value: null,
                        })
                        this.$store.commit('updateField', {
                            key: 'basicInfo.dateOfBirth',
                            value:null,
                        })
                        this.$store.commit('updateField', {
                            key: 'documentInfo.ocrPicture.fileName',
                            value: null,
                        })
                }  
                if(TypesForGender.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.genderId',
                        value: null,
                    })
                }
                if(TypesForNationality.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationalityId',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationality',
                        value: null,
                    })
                }
                if( TypesForIdentityInfo.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'identityInfo.number',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.expiryDate',
                        value:null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.documentSummary',
                        value: {}
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.documentSummaryBack',
                        value: {}
                    })
                
                }

                if( TypesForPassport.includes(cardType))
            {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.number',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.expiryDate',
                        value: null,
                    })
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.documentSummary',
                        value: {}
                    })
                    // this.$store.commit('updateField', {
                    //     key: 'identityInfo.isLifetimeExpiry',
                    //     value: null,
                    // })
                }
            
                if( this.country == 'Pakistan' && TypeForFatherName.includes(cardType)){
                    this.$store.commit('updateField', {
                        key: 'basicInfo.fatherName',
                        value: null,
                    })
                }
            
            },
  
        async ocrValidation(value,side)
        {
            try {
                if (process.env.VUE_APP_COUNTRY == 'Pakistan' && this.formData2.documentValidation && this.$store.getters.form.type!='company') {
                    const formData = new FormData()
                    formData.append(
                        'filePath',
                        // `${process.env.VUE_APP_API_URL}files/customers/${value}`
                        `http://localhost:3004/customers/${value}`

                    )
                    formData.append('cardType',this.$store.getters.getField('identityInfo.cardType'))
                    formData.append('cardSide',side)
                    formData.append('type', 'id')
                    formData.append('Country', `${process.env.VUE_APP_COUNTRY.toUpperCase()}`)
                    formData.append('IdType', this.$store.getters.getField('identityInfo.type'))

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    if(side=='FRONT')
                    {
                        this.validateFront = true
                    }
                    else if(side=='BACK')
                    {
                        this.validateBack = true
                    }
                    this.redirection = true

                    this.$store.commit('setLoading', true)
                    const {data} = await request
                        .post('ocr/', formData, {
                            headers,
                        })
                        .then(async (response) => {

                            if (response.status && response.status == 200 && response.data && response.data.ocr) {

                                let responseData = response.data.ocr

                                // Get Records Gender then set Gender Value

                                let genderType = ''
                                if(responseData.gender)
                                {
                                    if(responseData.gender!='' && this.$store.getters.getField('identityInfo.cardType')=='SMART')
                                    {
                                        if (responseData.gender == 'F') {
                                            genderType = 'Female'
                                        } else if (responseData.gender == 'M') {
                                            genderType = 'Male'
                                        }
                                    }
                                    else if(this.$store.getters.getField('identityInfo.cardType')=='URDU')
                                    {
                                        if (responseData.idnumber && responseData.idnumber!='') {
                                            const str = responseData.idnumber
                                            const last = str.charAt(str.length - 1)
                                            if (parseInt(last) % 2 == 0) {
                                                genderType = 'Female'
                                            }

                                            // if the number is odd
                                            else {
                                                genderType = 'Male'
                                            }
                                        }
                                    }
                                    if(genderType!='')
                                    {
                                        await this.getRecords('genders')

                                        let genderId = ''
                                        if (this.associateData) {
                                            this.associateData.forEach((element) => {
                                                // const str = responseData.gender
                                                const str2 =
                                                    genderType.charAt(0).toUpperCase() +
                                                    genderType.slice(1)
                                                if (element.title == str2) {
                                                    genderId = element._id
                                                }
                                            })
                                        }
                                        this.$store.commit('updateField', {
                                            key: 'basicInfo.gender',
                                            value: genderType,
                                        })
                                        this.$store.commit('updateField', {
                                            key: 'basicInfo.genderId',
                                            value: genderId,
                                        })
                                    }
                                }



                                // End

                                // Get Records Nationality then set Nationality Value

                                this.associateData = []

                                if(responseData.countryofstay)
                                {
                                    await this.getRecords('nationalities')

                                    let natId = ''
                                    let nat = ''
                                    if (this.associateData) {
                                        this.associateData.forEach((element) => {
                                            const str = responseData.countryofstay
                                            const str2 =
                                                str.charAt(0).toUpperCase() + str.slice(1)
                                            if (element.title == str2) {
                                                natId = element._id
                                                nat = element.title
                                            }
                                        })
                                    }
                                    this.$store.commit('updateField', {
                                        key: 'basicInfo.nationalityId',
                                        value: natId,
                                    })
                                    this.$store.commit('updateField', {
                                        key: 'basicInfo.nationality',
                                        value: nat,
                                    })
                                }
                                if(responseData.idnumber)
                                {
                                    let idNumber = (responseData.idnumber).replace('-','')
                                    idNumber = idNumber.replace('-','')
                                    this.$store.commit('updateField', {
                                        key: 'identityInfo.number',
                                        value: idNumber,
                                    })
                                }
                                if(responseData.dateofexpiry)
                                {
                                    this.$store.commit('updateField', {
                                        key: 'identityInfo.expiryDate',
                                        value: this.$moment(
                                            responseData.dateofexpiry,
                                            'D-M-Y'
                                        ).isValid()
                                            ? this.$moment(
                                                responseData.dateofexpiry,
                                                'D-M-Y'
                                            ).format('YYYY-MM-DD')
                                            : '',
                                    })

                                    this.$store.commit('updateField', {
                                        key: 'identityInfo.isLifetimeExpiry',
                                        value: "Yes",
                                    })
                                }
                                if(responseData.name)
                                {
                                    this.$store.commit('updateField', {
                                        key: 'basicInfo.firstName',
                                        value: responseData.name,
                                    })
                                }
                                if(responseData.fathername)
                                {
                                    this.$store.commit('updateField', {
                                        key: 'basicInfo.fatherName',
                                        value: responseData.fathername,
                                    })
                                }
                                if(responseData.dob)
                                {
                                    this.$store.commit('updateField', {
                                        key: 'basicInfo.dateOfBirth',
                                        value: this.$moment(
                                            responseData.dob,
                                            'D-M-Y'
                                        ).isValid()
                                            ? this.$moment(
                                                responseData.dob,
                                                'D-M-Y'
                                            ).format('YYYY-MM-DD')
                                            : '',
                                    })
                                }
                            }
                            else
                            // if (response.data.status == 203)
                            {
                                this.redirection = false
                                if(side=='FRONT')
                                {
                                    this.validateFront = false
                                }
                                else if(side=='BACK')
                                {
                                    this.validateBack = false
                                }
                                let msg ="Something went wrong, please try again!"
                                if(response && response.data && response.data.data)
                                {
                                    msg = response.data.data
                                }
                                    this.$store.commit(
                                    'setError',
                                    msg
                                )
                            }
                        })
                        .catch((error) => {
                            console.log('catch', error)
                        })
                    this.$store.commit('setLoading', false)
                }

            }catch (e) {
                console.log('OCR error 1',e)
            }
        },
         async consentFormDownload(){
          
          await axios({
                       method: 'get',
                       url: `${process.env.VUE_APP_API_URL}files/logo/consentForm.pdf`,
                       responseType: 'blob',
                   }).then((response) => {
                       const url = window.URL.createObjectURL(new Blob([response.data]))
           const link = document.createElement('a')
           link.href = url
           link.setAttribute(
               'download',
               `consentForm.pdf`
           )
           document.body.appendChild(link)
           link.click()

                   })
       
           
       },
        async prePopulate(){
            if(!this.$store.state.registration.form.documentInfo.otherDocuments){
                let docs = this.customerDetails.documentInfo.otherDocuments
                let size
                for(var i=0; i<docs.length;i++){

                    let url = `${process.env.VUE_APP_FILE_SERVICE_URL}customer-documents/${docs[i].fileName}`
                    await fetch(url, {
                        method: 'HEAD'
                    })
                        .then(response => response.headers.get('Content-Length'))
                        .then(s => size=s);
                    var file = { size:size, name: docs[i].originalFileName,...docs[i] };
                    await this.$refs.myVueDropzone.manuallyAddFile(file, url);
                }
                this.$store.commit('updateField', {
                    key: 'documentInfo.otherDocuments',
                    value: docs,
                })
            }else{
                let docs = this.$store.state.registration.form.documentInfo.otherDocuments
                let size
                for(var i=0; i<docs.length;i++){

                    let url = `${process.env.VUE_APP_FILE_SERVICE_URL}customer-documents/${docs[i].fileName}`
                    await fetch(url, {
                        method: 'HEAD'
                    })
                        .then(response => response.headers.get('Content-Length'))
                        .then(s => size=s);
                    var file = { size:size, name: docs[i].originalFileName,...docs[i] };
                    await this.$refs.myVueDropzone.manuallyAddFile(file, url);
                }
                this.$store.commit('updateField', {
                    key: 'documentInfo.otherDocuments',
                    value: docs,
                })
            }
// })


        },

        onError(file,message,xhr)
        {
            this.$refs.myVueDropzone.removeFile(file)
            this.$store.commit('setError', message)

        },
        onFileRemove(file) {

            if(this.$route.name=='deep-registration-upload-document')
            {
                let arr = []
                if (this.$store.state.registration.form.documentInfo.otherDocuments !== undefined) {
                    if(this.$store.state.registration.form.documentInfo.otherDocuments.length > 1)
                    {
                        this.$store.state.registration.form.documentInfo.otherDocuments.forEach((value, index) => {

                            if (value.uploadID == file.uploadID) {

                            } else {
                                let fileObj = {
                                            fileName: value.fileName,
                                            originalFileName:
                                            value.originalFileName,
                                            uploadID: value.uploadID,
                                        }
                                arr.push(fileObj)
                                this.updateOriginalFileName(arr)

                            }
                        });
                    }
                    else
                    {
                        this.updateOriginalFileName(arr)
                    }
                }
            }

        },
        afterComplete(file) {
            let response = JSON.parse(file.xhr.response)
            let fileObj = {
                'fileName': response.data.fileName,
                'originalFileName': file.name,
                'uploadID': file.upload.uuid
            }
            let arr = []
            if (this.$store.state.registration.form.documentInfo.otherDocuments !== undefined) {
                arr = this.$store.state.registration.form.documentInfo.otherDocuments
            }
            arr.push(fileObj)
            this.updateOriginalFileName(arr)
        },
        updateOriginalFileName(newValue) {
            this.$store.commit('updateField', {
                key: 'documentInfo.otherDocuments',
                value: newValue,
            })

        },
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.liveness = data.data.liveness
                        this.nameScreening = data.data.nameScreening
                        this.riskFactor = data.data.riskFactor
                        this.documentUpload = data.data.documentUpload
                        this.documentValidation = data.data.documentValidation
                        this.formData2.documentValidation = data.data.documentValidation
                        this.degreeCheck = data.data.degreeCheck
                        this.employmentCheck = data.data.employmentCheck
                        if (this.documentUpload == false ) {
                            if(this.$store.getters.form.type!='company')
                            {
                                this.$router.push({name: 'deep-registration-record-video',params:{source:this.$route.params.source}})
                            }
                            else
                            {
                                this.$router.push({name: 'deep-registration-setup-profile',params:{source:this.$route.params.source}})

                            }
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async onSubmit() {
            if (this.validateBack && this.validateFront) {

                // validate the form fields
                const result = await this.$validator.validateAll()

                // Check if validation fails
                if (result) {
                    // this.$store.commit('setLoading', true)
                    // this.soundon()

                    if (this.$route.meta.publicRegistration === true) {
                        if ((this.documentUpload === false || this.liveness === true) && this.$store.getters.form.type!='company') {
                            this.$router.push({
                                name: 'deep-registration-record-video',
                                params: {
                                    dataSegmentId: this.dataSegmentId,
                                    token: this.$route.params.token,
                                    source:this.$route.params.source
                                },
                            })
                        }
                        else {
                            this.$router.push({
                                name: 'deep-registration-setup-profile',
                                params: {
                                    dataSegmentId: this.dataSegmentId,
                                    token: this.$route.params.token,
                                    source:this.$route.params.source
                                },
                            })
                        }
                    } else {
                        this.$router.push('/register-customer/record-video')
                    }
                } else {
                    this.$store.commit('setError', this.errors.all()[0])
                }
            } else {
                this.$store.commit('setError', 'Your uploaded document has not been verified by our system, please try again.')
            }
        }, // End of onSubmit() method
        // soundon() {
        //     const sound =
        //         'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
        //     this.soundeffect.src = sound
        //     this.$store.commit('updateField', {
        //         key: 'soundSrc',
        //         value: this.soundeffect,
        //     })
        // },

        async getBrandingData() {
            let { data } = await viewBrandingApi.list({deeplink:true,dataSegmentId:this.dataSegmentId})
            this.$store.commit('setDisplaySetting', data.data)
            if(data.data.bgImages)
            {
                if(this.$store.getters.form.type!='company')
                {
                    this.cardImageUrl =  'logo/'+data.data.bgImages.idCard.fileName
                }
                else
                {
                    this.cardImageUrl =  'logo/'+data.data.bgImages.companyLicense.fileName
                }
            }
        },

        async getFormData() {
            try {
                    
                //fetch data from the url & send request
                let { data } = await request({
                    url: `/customers/fetch`,
                    method: 'get',
                    params: {
                        token: this.$route.params.token,
                    },
                })
                let isData = data && data.data

                    if (process.env.VUE_APP_COUNTRY != 'Pakistan') {
                        this.$store.commit('updateField', {
                            key: 'identityInfo.type',
                            value: 'passport',
                        })
                        if(isData ){
                        this.profileType = data.data.profileType
                        this.setMultipleUploadDocuments(data.data.profileType)
                         }
                    }else{
                        this.$store.commit('updateField', {
                            key: 'identityInfo.type',
                            value: 'id',
                        })
                    }

            if( isData ){
                this.$store.commit('updateField', {
                    key: 'idenfoId',
                    value: data.data.idenfoId,
                })
                if (data.data.identityInfo.type != null) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.type',
                        value: data.data.identityInfo.type,
                    })
                }
                //Mapping fields
                this.$store.commit('updateField', {
                    key: 'type',
                    value: data.data.type ? data.data.type : 'individual' ,
                })
                // token
                this.$store.commit('updateField', {
                    key: 'basicInfo.token',
                    value: this.$route.params.token,
                })

                // basic info
                this.$store.commit('updateField', {
                    key: 'basicInfo.firstName',
                    value: data.data.firstName,
                })
                this.$store.commit('updateField', {
                    key: 'basicInfo.middleName',
                    value: data.data.middleName ? data.data.middleName : '',
                })
                this.$store.commit('updateField', {
                    key: 'basicInfo.lastName',
                    value: data.data.lastName ? data.data.lastName : '',
                })
                this.$store.commit('updateField', {
                    key: 'basicInfo.fatherName',
                    value: data.data.fatherName ? data.data.fatherName : '',
                })

                this.$store.commit('updateField', {
                    key: 'contactInfo.email',
                    value: data.data.contactInfo.email,
                })

                this.$store.commit('updateField', {
                    key: 'contactInfo.confirmEmail',
                    value: data.data.contactInfo.email,
                })

                if (data.data.countryOfResidenceId != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.countryOfResidenceId',
                        value: data.data.countryOfResidenceId,
                    })
                }
                if (data.data.profileType != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.profileType',
                        value: data.data.profileType,
                    })
                }


                if (data.data.countryOfResidence && data.data.countryOfResidence.title != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.countryOfResidence',
                        value: data.data.countryOfResidence.title,
                    })
                }

                if (data.data.genderId != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.genderId',
                        value: data.data.genderId,
                    })
                }
                if (data.data.genderId != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: data.data.gender.title,
                    })
                }
                if (data.data.dateOfBirth != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.dateOfBirth',
                        value: data.data.dateOfBirth,
                    })
                }

                if (data.data.nationalityId != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationalityId',
                        value: data.data.nationalityId,
                    })
                }

                if (data.data.nationality && data.data.nationality.title != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationality',
                        value: data.data.nationality.title,
                    })
                }

                if (data.data.basicInfo.companyStatus != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.companyStatus',
                        value: data.data.basicInfo.companyStatus,
                    })
                }

                if (data.data.basicInfo.companyType != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.companyType',
                        value: data.data.basicInfo.companyType,
                    })
                }
                //contact info

                if (data.data.contactInfo.address != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.address',
                        value: data.data.contactInfo.address,
                    })
                }

                if (data.data.contactInfo.stateId != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.stateId',
                        value: data.data.contactInfo.stateId,
                    })
                    this.$store.commit('updateField', {
                        key: 'contactInfo.state',
                        value: data.data.contactInfo.state[0].title,
                    })
                }
                else if(data.data.contactInfo.stateId == null)
                {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.state',
                        value: data.data.contactInfo.state,
                    })
                }

                if (data.data.contactInfo.city != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.city',
                        value: data.data.contactInfo.city,
                    })
                }

                if (data.data.contactInfo.postalCode != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.postalCode',
                        value: data.data.contactInfo.postalCode,
                    })
                }

                if (data.data.contactInfo.isdCode != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.isdCode',
                        value: data.data.contactInfo.isdCode,
                    })
                }

                if (data.data.contactInfo.isdCountryCodeId != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.isdCountryCodeId',
                        value: data.data.contactInfo.isdCountryCodeId,
                    })
                }


                if (data.data.contactInfo.phoneNumber != null) {
                    this.$store.commit('updateField', {
                        key: 'contactInfo.phoneNumber',
                        value: data.data.contactInfo.phoneNumber,
                    })
                }

                if (data.data.occupationInfo.workTypeId != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.workTypeId',
                        value: data.data.occupationInfo.workTypeId,
                    })
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.workType',
                        value: data.data.occupationInfo.workType[0].title,
                    })

                     //for seting the industry field required or not required
                     let workTypes = ['Salaried-General','Self-Employed / Business Owner', 'Salaried-Executive Level'] 
                     if (data.data.occupationInfo.workType[0] && !workTypes.includes(data.data.occupationInfo.workType[0].title)) {
                       this.$store.commit('setValue', {
                       key: 'isIndustrial',
                       value: false,
                     })
                }
                    
                }

                if (data.data.occupationInfo.industryId != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industryId',
                        value: data.data.occupationInfo.industryId,
                    })
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industry',
                        value: data.data.occupationInfo.industry[0].title,
                    })
                } 
                if (data.data.occupationInfo.taxId != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.taxId',
                        value: data.data.occupationInfo.taxId,
                    })
                }
                if (data.data.occupationInfo.tradeLicenseNumber != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.tradeLicenseNumber',
                        value: data.data.occupationInfo.tradeLicenseNumber,
                    })
                }
                if (data.data.occupationInfo.tradeLicenseExpiryDate != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.tradeLicenseExpiryDate',
                        value: data.data.occupationInfo.tradeLicenseExpiryDate,
                    })
                }
                if (data.data.occupationInfo.tradeLicenseIncorporationLocation != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.tradeLicenseIncorporationLocation',
                        value: data.data.occupationInfo.tradeLicenseIncorporationLocation,
                    })
                }

                if (data.data.identityInfo.passport.number != null) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.number',
                        value: data.data.identityInfo.passport.number,
                    })
                }
                if (data.data.identityInfo.passport.expiryDate != null) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.passport.expiryDate',
                        value: data.data.identityInfo.passport.expiryDate,
                    })
                }
                if (data.data.occupationInfo.companyName != null) {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.companyName',
                        value: data.data.occupationInfo.companyName,
                    })
                }else if(data.data.parents && data.data.parents.length > 0){
                    this.$store.commit('updateField', {
                        key: 'parents',
                        value: data.data.parents,
                    })
                }

                //Identity info

                if (data.data.identityInfo.type != null) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.type',
                        value: data.data.identityInfo.type,
                    })
                }

                if (data.data.identityInfo.number != null) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.number',
                        value: data.data.identityInfo.number,
                    })
                }
                if (data.data.identityInfo.isLifetimeExpiry && data.data.identityInfo.isLifetimeExpiry != null) {

                    this.$store.commit('updateField', {
                        key: 'identityInfo.isLifetimeExpiry',
                        value: data.data.identityInfo.isLifetimeExpiry,
                    })
                }

                if (data.data.identityInfo.expiryDate != null) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.expiryDate',
                        value: data.data.identityInfo.expiryDate,
                    })
                }
                if (data.data.basicInfo.hasOtherNationalities != null) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.hasOtherNationalities',
                        value: data.data.basicInfo.hasOtherNationalities,
                    })
                }
                if ((data.data.basicInfo.otherNationalities).length > 0 && data.data.basicInfo.otherNationalities[0] !="") {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.otherNationalities',
                        value: data.data.basicInfo.otherNationalities,
                    })
                }
                if ((data.data.accountInfo.products).length > 0 && data.data.accountInfo.products[0] !="") {
                    this.$store.commit('updateField', {
                        key: 'accountInfo.products',
                        value: data.data.accountInfo.products,
                    })
                }
                if (data.data.accountInfo.productOffered) {
                    this.$store.commit('updateField', {
                        key: 'accountInfo.productOffered',
                        value: data.data.accountInfo.productOffered,
                    })
                }
            }

            } catch (error) { }
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
        async getRecords(association) {
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: `/configurations/${association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                this.associateData = data.data
            } catch (error) {
                console.log(error)
            }
        }, // End of getRecords() method
        setMultipleUploadDocuments(profileType) {

            if (profileType == 'Citizen') {
                this.fieldVisaPage.show = false
                // this.fieldVisaPage.isRequired = false
            } else if (profileType == 'Non-resident (tourist)') {
                this.fieldVisaPage.show = false
                // this.fieldVisaPage.isRequired = false
                this.fieldEmiratesID.show = false
                this.fieldEmiratesIDBack.show = false
                // this.fieldEmiratesID.isRequired = false
            } else {
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
